module.exports = __webpack_public_path__ + "static/img/qa.ea280a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/me-question/qa.png
// module id = yO6o
// module chunks = 1